export { makeRumPublicApi } from './boot/rumPublicApi';
export { startRum } from './boot/startRum';
export { LifeCycle, LifeCycleEventType } from './domain/lifeCycle';
export { RumSessionPlan } from './domain/rumSessionManager';
export { getMutationObserverConstructor } from './browser/domMutationObservable';
//# sourceMappingURL=index.js.map